import { render, staticRenderFns } from "./tab-row.vue?vue&type=template&id=1230b931&scoped=true&"
import script from "./tab-row.vue?vue&type=script&lang=js&"
export * from "./tab-row.vue?vue&type=script&lang=js&"
import style0 from "./tab-row.vue?vue&type=style&index=0&id=1230b931&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1230b931",
  null
  
)

export default component.exports